export function DashboardPinIcon({ active }) {
  const rectStroke = active ? '#547A42' : '#DAE4D5'
  const stroke     = active ? '#547A42' : '#A7C199'
  const fill       = active ? '#547A42' : 'white'

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white"/>
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke={rectStroke}/>
      <g clipPath="url(#clip0_dash_pin)">
        <path d="M11.75 28.25L17.3738 22.6262" stroke={stroke} fill="none" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M27.2605 16.6945L22.7764 21.1786C23.2747 23.0446 22.7919 25.1181 21.328 26.582L13.418 18.672C14.8818 17.2081 16.9553 16.7253 18.8214 17.2236L23.3055 12.7395" stroke={stroke} fill={fill} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22.3203 11.7472L28.2528 17.6797" stroke={stroke} fill="none" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_dash_pin">
          <rect width="18" height="18" fill="white" transform="translate(11 11)"/>
        </clipPath>
      </defs>
    </svg>
  )
}
